import { useTranslation } from 'react-i18next'

import { Button } from '../buttons/Button'
import { Buttons } from '../buttons/Buttons'

import { Language } from '../../types/language'

type LanguageToggleProps = {
  language: Language
  onLanguageChange: (language: Language) => void
  disabled?: boolean
  labelClassName?: string
}

export const LanguageToggle = ({
  language,
  onLanguageChange,
  disabled = false,
  labelClassName = '',
}: LanguageToggleProps) => {
  const { t } = useTranslation('nav')

  return (
    <>
      <span
        className={`foot-label foot-language-label ${labelClassName}`.trim()}
      >
        {t('foot-bar.language')}
      </span>
      <Buttons className="foot-toggle">
        <Button
          variant="ghost"
          className={`foot-option rounded-pill ${
            language === Language.EN ? 'on' : ''
          }`}
          label={Language.EN}
          onClick={() => onLanguageChange(Language.EN)}
          disabled={disabled}
          aria-label={t('foot-bar.english')}
        />
        <Button
          variant="ghost"
          className={`foot-option rounded-pill ${
            language === Language.RO ? 'on' : ''
          }`}
          label={Language.RO}
          onClick={() => onLanguageChange(Language.RO)}
          disabled={disabled}
          aria-label={t('foot-bar.romanian')}
        />
      </Buttons>
    </>
  )
}
